export function compareDates(inputDate: Date): boolean {
    const currentDate = new Date();

    const localDateString = currentDate.toLocaleDateString("en-CA");
    const formattedCurrentDate = `${localDateString}T00:00:00.000+00:00`;

    const localInputDateString = inputDate.toLocaleDateString("en-CA");
    const formattedInputDate = `${localInputDateString}T00:00:00.000+00:00`;

    return formattedCurrentDate === formattedInputDate;
}
